<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import URL from '@/views/cms/util/url'
import UPDATE from '@/components/page/update.vue'
import Qs from 'qs'
import axios from 'axios'
import DateUtil from "@/utils/IM/tradeDataUtil";
let lang={0:"cn",1:"national"}
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
  },
  mounted() {
    this.$refs.childTable.defaultQueryData();
  },
  methods: {
    bthClick(clickName, row) {
     if (clickName == 'delete') {
        this.dataChange(URL.article.del, { ipAddress: row.ipAddress,ipPort:row.ipPort }, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data){
      if("查询" == clickName){
        this.queryData = data;
        this.$refs.childTable.defaultQueryData(data);
      }else if("添加" == clickName){
        this.addOp();
      }
    },
    addOp() {
      this.$axios.post(URL.spider.ipProxyAdd, {}).then(res => {
        if (res.code == 0) {
          this.$refs.childTable.defaultQueryData();
        }
      })
    },
  },
  data () {
    return {
      queryData:{},
      /*from查询表单*/
      formData:{
        hasLable: true,
        cols:[
          { title: 'type', field: 'type',type:2,optionList:lang},
          {click:"查询",auth:"cms:spider:ipproxy:list"},
          {click:"添加",auth:"cms:spider:ipproxy:add"},
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: URL.spider.ipProxy,  //请求路径和参数
        selection: true,
        sequence: true,
        cols: [
          { title: 'ipAddress', field: 'ipAddress'},
          { title: 'ipPort', field: 'ipPort'},
          { title: 'ipType', field: 'ipType'},
          { title: 'lang', field: 'lang'},

          {
            title: '操作',
            btnClick: [{
              name: '删除',
              click: 'delete',
              type: 'primary',
              icon: 'el-icon-delete',
              auth: 'cms:ipproxy:del'
            }]
          }
        ]
      }
    }
  }
}
</script>
